// utils/storage.js
export const Storage = {
    /**
     * 保存数据到 localStorage
     * @param {string} key 键名
     * @param {any} value 任意类型的值
     */
    set(key, value) {
        // 包装成 {type, data}
        const item = {
            type: typeof value,
            data: value
        }
        localStorage.setItem(key, JSON.stringify(item))
    },

    /**
     * 从 localStorage 读取数据
     * @param {string} key 键名
     * @param {any} defaultValue 默认值（可选）
     * @returns {any} 原始类型的值
     */
    get(key, defaultValue = null) {
        const raw = localStorage.getItem(key)
        if (!raw) return defaultValue

        try {
            const parsed = JSON.parse(raw)
            // 如果是对象结构，则还原 data，否则直接返回
            if (parsed && parsed.hasOwnProperty('data')) {
                return parsed.data
            }
            return parsed
        } catch {
            // 不可解析的情况（例如手动修改或旧数据）
            return defaultValue
        }
    },

    /**
     * 删除指定 key
     */
    remove(key) {
        localStorage.removeItem(key)
    },

    /**
     * 清空所有
     */
    clear() {
        localStorage.clear()
    }
}